import Flex from '@creditflowresearch/uilib/Flex';
import UpgradePlanButton from '@/creditflowresearch/ui/common/components/UpgradePlanButton';
import { Link } from '@framework/router/Next/Link';
import cfrUrl from '@/creditflowresearch/infrastructure/url';

import styles from './TogglingFiltersFallback.module.scss';

const TogglingFiltersFallback = () => (
  <Flex
    className={ styles.fallbackWrapper }
    align="center"
    gap={ 20 }
  >
    <div className={ styles.description }>
      For complete access to datasets on this page and more, upgrade to a&nbsp;
      <Link to={ cfrUrl.getPricingPageUrl() }>Professional plan</Link>.
    </div>
    <UpgradePlanButton className={ styles.upgradePlanButton } />
  </Flex>
);

export default TogglingFiltersFallback;
